import { ActivityEvent } from 'components/ActivityEvent/Types'
import { generatePath, useHistory } from 'react-router-dom'
import { DOC_ACTIVITY_PATH } from 'paths'
import { Clock1 } from 'blaze-ui/icons/20'
import { Button } from 'blaze-ui/Button'

interface Props {
  event: ActivityEvent
}

export const HistoryButton = ({ event }: Props) => {
  const history = useHistory()

  return (
    <Button
      variant="secondary"
      onPress={() => history.push(generatePath(DOC_ACTIVITY_PATH, { slug: event.article.slug, eventId: event.id }))}
      frontIcon={Clock1}
    >
      History
    </Button>
  )
}
